import React, { useState } from "react";
import { showApiError} from "../utilities";
import { AutoComplete, Button, Input, DatePicker, Badge, Form } from "antd";
import debounce from "lodash.debounce";
import "moment/locale/en-nz";
import moment from "moment";
import { ContributorsAutoCompleteApi,  fetchMode } from "../../services/apiService";
import { useGlobal } from 'reactn';
import { user_roles } from '../enums'

function ContributionFilter(props) {

  const userRole = window.sessionStorage.getItem("UserRole") || "";
  const dateFormat = "DD-MM-YYYY";
  const [fromDate, setFromDate] = useGlobal( "fromDate" )
  const [toDate, setToDate] = useGlobal("toDate")
  const [member , setMember] = useGlobal("member")
  const [memberList, setMemberList] = useState([]) 


  let gMember = {...member} 


  function fnSetMember (item) {
    let offeringNo = "";
    let selectedMember = "";
    let contributorId = -1;
    if (item) {
      selectedMember = item.text.substr(item.text.indexOf(" ") + 1);
      offeringNo = item.text.substr(0, item.text.indexOf(" "));
      contributorId = item.id;
    }

    wrapSetMember({ selectedMember, offeringNo, contributorId });
  };

  
  function handleOnSelect(selectedValue) {
    //console.log("selectedValue: " + selectedValue);
    let selectItem = memberList.find(
      item => item.value === parseInt(selectedValue)
    );
    fnSetMember(selectItem);
    //console.log(member);
  };

  function handleOnChange(changedValue ){
    //console.log("changedValue:" + changedValue);
    //this.setState({ contributorId: changedValue });
  };

  function wrapSetMember( obj ) {
    setMember(obj)
    gMember = {...obj} 
  }

  function handleSearch (searchValue ){
    wrapSetMember({ selectedMember: searchValue, offeringNo: "", contributorId: -1 })
    if (searchValue === "") {
        setMemberList([]) 
    } else {
      debounceLoadData(searchValue)
    }
  };

  function handleOnFocus (e) {
    // this.setState({ memberList: [] });
  };

  function handleOnBlur (e) {
    //console.log("onBlur:" + e);
    if (member.offeringNo === "") {
      debounceAutoPick();
    }
  };

  const debounceLoadData = debounce(loadData, 200);
  const debounceAutoPick = debounce(autopick, 220);

    // class helper functions
   function autopick()  {
      // fill the offering number using the return autocomplete array if nothing has pick
      // this is the case when user enter an offering number an then tab out without selecting anything
      let item ;
      if (memberList.length > 0) {
        item = memberList[0];
      }
      fnSetMember(item);
    };
  
  function loadData(qString) {
    ContributorsAutoCompleteApi(qString)
      .then(json => {
        if (typeof json === "string") {
          throw new Error(json);
        } else {
          if (fetchMode === "local") {
            //console.log("localmode, local process");
            json = localPostProcess(qString, json);
          }
          setMemberList(json)
        }
      })
      .catch(error => {
        showApiError(error);
      });
  }

  // this function only use for local development to simulate the autocomplete search
  // it won't be use in production
  function localPostProcess(str, members) {
    function byValue(search) {
      return function(element) {
        if (element.value === parseInt(search)) {
          return element;
        }
      };
    }

    function byName(search) {
      return function(element) {
        if (element.text.toLowerCase().includes(search.toLowerCase())) {
          return element;
        }
      };
    }

    if (isNaN(str)) {
      return members.filter(byName(str));
    } else {
      return members.filter(byValue(str));
    }
  }


  function handleToDateChange( m, s) {
    //console.log(`${s}`)
    //toDate = m 
    setToDate(m)
  }

  function handleFromDateChange( m, s) {
    //console.log(`${s}`)
    setFromDate( m )
  }

  //function handleGroupbyChange(e) {
  //  groupBy = e.target.value
  //}

  function handleSeachClick(e) {
    let groupBy = e.target.value ;
    setTimeout(() => {
      doSearch( groupBy)
    }, 250);
    // let contId=0
    // if (member.contributorId) {
    //   contId = parseInt(member.contributorId)
    // }
    // let search = { 
    //   fromDate: fromDate.format("YYYYMMDD"),
    //   toDate: toDate.format("YYYYMMDD"),
    //   contId,
    //   offeringNo: member.offeringNo,
    //   selectedMember: member.selectedMember,
    //   groupBy: e.target.value
    // }

    // props.doSearch(search)
  }
   
  function doSearch( groupBy ) {
    console.log("doSearch: " + gMember.offeringNo + ":" + gMember.selectedMember)

    let contId=0
    if (gMember.contributorId) {
      contId = parseInt(gMember.contributorId)
    }
    let search = {
      fromDate: fromDate.format("YYYYMMDD"),
      toDate: toDate.format("YYYYMMDD"),
      contId,
      offeringNo: gMember.offeringNo,
      selectedMember: gMember.selectedMember,
      groupBy: groupBy
    }
    props.doSearch(search)
  }

  function ReportButton() {

    if(props.groupBy < 0) {
      return (
        <Form.Item >
          <Button icon="search" type="primary" onClick={handleSeachClick} value={-1} >{props.button1Title ? props.button1Title : 'Report' }</Button>&nbsp;
        </Form.Item>
      )
    }
    return (
      <Form.Item label="Group by">
      <Button icon="search" type="primary" onClick={handleSeachClick} value={0} >Date</Button>&nbsp;
      <Button icon="search" type="primary" onClick={handleSeachClick} value={1}>Fund</Button>
      </Form.Item>
    )
  }

  function handleSetDates(dr) {
    let today = new Date()
    let start
    let end
    if (dr === "y") {
      //console.log("set last year");
      let year = today.getFullYear()
      if (today.getMonth() > 3) {
        year = year - 1
      } else {
        year = year - 1
      }
      // last year
      start = new Date(year, 3, 1)
      end = new Date(year + 1, 2, 31)

    } else {
      // last month
      if (today.getMonth() === 0) {
        start = new Date(today.getFullYear() - 1, 12, 1)
        end = new Date(today.getFullYear(), 1, 0)
      } else {
        start = new Date(today.getFullYear(), today.getMonth() - 1, 1)
        end = new Date(today.getFullYear(), today.getMonth(), 0)
      }
    }
    setFromDate(moment(start))
    setToDate(moment(end))

    //console.log(`date range: ${start.toLocaleDateString()} ${end.toString()}`)

  }
  return (
    <div className="panel">
      <Form layout="inline">
        {userRole === user_roles.SUMMARY_ONLY ? null :
          (<div><Form.Item label="Member (Optional): " >
            <AutoComplete
            style={{ width: "300px" }}
            backfill={false}
            dataSource={memberList}
            onSearch={handleSearch}
            onChange={handleOnChange}
            onSelect={handleOnSelect}
            onBlur={handleOnBlur}
            value={member.selectedMember}
            optionLabelProp="value"
          >
            <Input onFocus={handleOnFocus} />
          </AutoComplete> &nbsp;
          <Badge
            count={member.offeringNo}
            showZero
            style={{
              float: "right",
              backgroundColor: "#fff",
              color: "#999",
              boxShadow: "0 0 0 1px #d9d9d9 inset"
            }}
            overflowCount={10000}
            /></Form.Item> <br /> </div>)}
        
        <Form.Item label="From">
          <DatePicker
            allowClear={false}
            autoFocus={true}
            value={fromDate}
            format={dateFormat}
            onChange={handleFromDateChange}
          />
        </Form.Item>
        <Form.Item label="To">
          <DatePicker
            allowClear={false}
            autoFocus={true}
            value={toDate}
            format={dateFormat}
            showToday={true}
            onChange={handleToDateChange}
          />
        </Form.Item>
        <Form.Item>
          <Button type="default" shape="round" size="small" onClick={() => handleSetDates("y")} >Last year</Button>&nbsp;
          <Button type="default" shape="round" size="small" onClick={() => handleSetDates("m")} >Last month</Button>
        </Form.Item>
        <ReportButton />
      </Form>
    </div>
  );
}

export default ContributionFilter;
